import axios from "axios";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { HiX } from "react-icons/hi";

function AssignTask({ id, onClose, staff, getAllStaffs }) {
  const [loading, setLoading] = useState(false); //State for loader
  const [tasks, setTasks] = useState([]); //State to store all the tasks which are not assigned any staff
  const [selectedTasks, setSelectedTasks] = useState([]); //State to track checked tasks which are to be assigned to the

  //Function to get all the tasks which are not assigned to any staff
  const getAllTasksWithNoStaff = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/task/get-tasks-with-no-staff`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of getAllTasksWithNoStaff", response.data);
        setTasks(response.data.tasks);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getAllTasksWithNoStaff();
  }, []);

  //Storing all the pending not-assigned staff tasks
  const pendingNotAssignedTasks = tasks?.filter(
    (task) => task.status === "Pending"
  );

  console.log("Pending not assigned tasks: ", pendingNotAssignedTasks);

  //Storing all the assigned pending tasks to the staff
  const pendingTasks = staff?.tasks?.filter(
    (task) => task.status === "Pending"
  );

  useEffect(() => {
    const pendingTaskIds = pendingTasks.map((task) => task._id);
    setSelectedTasks(pendingTaskIds);
  }, [staff.tasks]);

  //Function to handle check box change
  const handleCheckBoxChange = (taskId) => {
    if (selectedTasks.includes(taskId)) {
      setSelectedTasks(selectedTasks.filter((id) => id !== taskId));
    } else {
      setSelectedTasks([...selectedTasks, taskId]);
    }
  };

  //Handle Submit
  const handleSubmit = () => {
    setLoading(true);
    const finalData = {
      tasks: selectedTasks,
      adminId: id,
    };

    let config = {
      method: "put",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/user/assign-tasks-to-staff/${staff._id}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: finalData,
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of assign tasks handleSubmit: ", response.data);
        setLoading(false);
        onClose();
        toast.success(response.data.message);
        getAllStaffs();
      })
      .catch((error) => {
        console.log(error);
        toast.error("Error in assigning tasks");
        setLoading(false);
      });
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm backdrop-brightness-75 "
      onClick={onClose}
    >
      <div
        className="relative max-h-[95%] w-[95%] max-w-2xl   overflow-y-auto rounded-lg bg-white p-8 shadow-lg  lg:px-6 lg:py-8"
        onClick={(e) => e.stopPropagation()}
      >
        <h1 className="mb-4 text-center text-3xl font-bold tracking-wide text-primary">
          Assign Tasks
        </h1>

        {/* Check Boxes */}
        <div className="flex flex-col justify-around md:flex-row ">
          <div className="flex flex-col gap-4 md:grid-cols-2 ">
            <h1 className=" text-lg font-semibold text-primaryText">
              Tasks not assigned to any staff
            </h1>
            {pendingNotAssignedTasks?.map((task, index) => (
              <div
                className="flex max-h-[90%] items-center gap-2 overflow-y-scroll"
                key={index}
              >
                <input
                  type="checkbox"
                  value={task._id}
                  checked={selectedTasks.includes(task._id)}
                  onChange={(e) => handleCheckBoxChange(e.target.value)}
                />
                <label htmlFor="task" className="text-lg font-medium ">
                  {task.name}
                </label>
              </div>
            ))}
          </div>

          <div className=" flex flex-col gap-4 md:grid-cols-2">
            <h1 className=" text-lg font-semibold text-primaryText">
              Pending tasks of{" "}
              <span className="text-primary">{staff.name}</span>
            </h1>
            {pendingTasks.length > 0 ? (
              pendingTasks?.map((task, index) => (
                <div
                  className="flex max-h-[90%] items-center gap-2 overflow-y-scroll"
                  key={index}
                >
                  <input
                    type="checkbox"
                    value={task._id}
                    checked={selectedTasks.includes(task._id)}
                    onChange={(e) => handleCheckBoxChange(e.target.value)}
                  />
                  <label htmlFor="task" className="text-lg font-medium ">
                    {task.name}
                  </label>
                </div>
              ))
            ) : (
              <p className="text-md text-center text-primaryText ">
                No Pending Tasks
              </p>
            )}
          </div>
        </div>

        <div className="my-2 flex gap-4 md:float-right">
          <button
            className="rounded bg-gray-300 px-2 py-1 font-bold text-primaryText shadow-md hover:bg-gray-500"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="rounded bg-primary px-2 py-1 font-bold text-white shadow-md hover:bg-hoverPrimary"
            onClick={handleSubmit}
          >
            {loading ? <div className="loaderButton"></div> : "Assign Tasks"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AssignTask;
